const separator = "_";

export function buildAffiliateMarketerKey(shopId: number, affiliateMarketerId: number) {
    return `${shopId}${separator}${affiliateMarketerId}`;
}

export function parseAffiliateMarketerKey(key: string): [shopId?: number, affiliateMarketerId?: number] {
    if (!key) return [];

    const [shopId, affiliateMarketerId] = key.split(separator);
    const parsedShopId = Number(shopId);
    const parsedAffiliateMarketerId = Number(affiliateMarketerId);

    if (Number.isNaN(parsedShopId) || Number.isNaN(parsedAffiliateMarketerId)) {
        return [];
    }

    return [parsedShopId, parsedAffiliateMarketerId];
}

export function getAffiliateMarketerIdsByShop(affiliateMarketerKeys: string[], shopId: number) {
    const affiliateMarketerIds = new Set<number>();

    affiliateMarketerKeys?.forEach((key) => {
        const [keyShopId, affiliateMarketerId] = parseAffiliateMarketerKey(key);

        if (keyShopId === shopId && typeof affiliateMarketerId === "number") {
            affiliateMarketerIds.add(affiliateMarketerId);
        }
    });

    return Array.from(affiliateMarketerIds);
}
